import styled, { css } from "styled-components";

import { BackOfficeLogoSize } from "./types";

export const LogoRoot = styled.div<{ $size: BackOfficeLogoSize }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ $size }) => ($size === "login" ? 14 : 10)}px;
  min-width: 0;
`;

// Shared by every variant's artwork.
export const MarkSvg = styled.svg`
  display: block;
  flex-shrink: 0;
`;

export const WordMark = styled.span<{ $size: BackOfficeLogoSize }>`
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  color: ${({ theme }) => theme.colors.fg.primary};

  ${({ $size }) =>
    $size === "login" &&
    css`
      align-items: flex-start;
    `}
`;

export const WordMarkTitle = styled.span<{ $size: BackOfficeLogoSize }>`
  font-family: ${({ theme }) => theme.colors.fonts.primary};
  font-size: ${({ $size }) => ($size === "login" ? 28 : 22)}px;
  font-weight: 700;
  line-height: ${({ $size }) => ($size === "login" ? 28 : 22)}px;
  letter-spacing: 0;
  white-space: nowrap;
  background: linear-gradient(90deg, #bfa7ff 0%, #7748fc 45%, #ba00d9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

// CRM gets away with a ~5px subtitle because its wordmark is one SVG: the glyphs are vector
// paths, not text. These are real DOM text under a 22px wordmark, so they need real px —
// they shipped at 5-6px and read as smudges. 13/12px is the smallest that stays legible.
export const WordMarkMeta = styled.span<{ $size: BackOfficeLogoSize }>`
  font-family: ${({ theme }) => theme.colors.fonts.primary};
  font-size: ${({ $size }) => ($size === "login" ? 14 : 10)}px;
  font-weight: 500;
  line-height: ${({ $size }) => ($size === "login" ? 15 : 11)}px;
  letter-spacing: 0;
  color: #9a7cff;
  white-space: nowrap;
`;

export const WordMarkVersion = styled.span<{ $size: BackOfficeLogoSize }>`
  font-family: ${({ theme }) => theme.colors.fonts.primary};
  font-size: ${({ $size }) => ($size === "login" ? 11 : 10)}px;
  font-weight: 600;
  line-height: ${({ $size }) => ($size === "login" ? 12 : 11)}px;
  letter-spacing: 0;
  color: #7748fc;
  white-space: nowrap;
`;
